// 车位信息
const parkingLotManageJurisdiction = [
  { id: "004025001", label: "添加", children: [] },
  { id: "004025002", label: "修改", children: [] },
  { id: "004025003", label: "删除", children: [] },
  { id: "004025004", label: "导入", children: [] },
  { id: "004025005", label: "导出", children: [] }
];

// 车位区域
const parkingLotAreaJurisdiction = [
  { id: "004029001", label: "添加", children: [] },
  { id: "004029002", label: "修改", children: [] },
  { id: "004029003", label: "删除", children: [] }
];

// 车位租赁
const parkingRentJurisdiction = [
  { id: "004030001", label: "添加", children: [] },
  { id: "004030002", label: "作废", children: [] },
  { id: "004030003", label: "导入", children: [] },
  { id: "004030004", label: "导出", children: [] }
];

// 车位收费规则
const parkingFeeRuleJurisdiction = [
  { id: "004031001", label: "添加", children: [] },
  { id: "004031002", label: "删除", children: [] },
  { id: "004031003", label: "修改", children: [] }
];

// 出入口相机
const parkingDeviceManagementJurisdiction = [
  { id: "004001001", label: "添加", children: [] },
  { id: "004001003", label: "修改", children: [] },
  { id: "004001002", label: "删除", children: [] },
  { id: "004001004", label: "导入", children: [] },
  { id: "004001005", label: "导出", children: [] }
];

// 出入口管理
const entAndExitManageJurisdiction = [
  { id: "004002001", label: "开闸", children: [] }
];

// 显示屏管理
const displayManageJurisdiction = [
  { id: "004003001", label: "添加", children: [] },
  { id: "004003003", label: "修改", children: [] },
  { id: "004003002", label: "删除", children: [] }
];

// 岗亭账号
const sentryBoxJurisdiction = [
  { id: "004004001", label: "添加", children: [] },
  { id: "004004002", label: "删除", children: [] },
  { id: "004004003", label: "修改", children: [] }
];

// 车辆管理
const parkingPaymentRecordJurisdiction = [
  { id: "004005001", label: "添加", children: [] },
  { id: "004005002", label: "删除", children: [] },
  { id: "004005003", label: "修改", children: [] },
  { id: "004005004", label: "导入", children: [] },
  { id: "004005005", label: "导出", children: [] }
];

// 黑名单
const blackListVehiclesManageJurisdiction = [
  { id: "004006001", label: "添加", children: [] },
  { id: "004006002", label: "删除", children: [] },
  { id: "004006003", label: "修改", children: [] }
];

// 白名单
const whiteListVehiclesManageJurisdiction = [
  { id: "004007001", label: "添加", children: [] },
  { id: "004007002", label: "删除", children: [] },
  { id: "004007003", label: "修改", children: [] }
];

// 包月车辆
const monthlyVehicleJurisdiction = [
  { id: "004008001", label: "导入", children: [] },
  { id: "004008002", label: "导出", children: [] },
  { id: "004008003", label: "添加", children: [] },
  { id: "004008004", label: "修改", children: [] },
  { id: "004008005", label: "删除", children: [] },
  { id: "004008006", label: "续费", children: [] },
  { id: "004008007", label: "退款", children: [] }
];

// 在场车辆
const vehiclesOnSiteJurisdiction = [
  { id: "004009001", label: "添加", children: [] },
  { id: "004009002", label: "删除", children: [] },
  { id: "004009003", label: "修改", children: [] },
  { id: "004009004", label: "导出", children: [] }
];

// 停车账单
const parkingBillJurisdiction = [
  { id: "004010001", label: "导出", children: [] }
];

// 包月账单
const parkingMonthBillJurisdiction = [
  { id: "004011001", label: "导出", children: [] }
];

// 包月收费
const monthlyPaymentJurisdiction = [
  { id: "004012001", label: "导出", children: [] }
];

// 临停收费
const temporaryStopJurisdiction = [
  { id: "004027001", label: "导出", children: [] }
];

// 进出记录
const parkingEntryAndExitRecordJurisdiction = [
  { id: "004013001", label: "导出", children: [] }
];

// 免费码使用记录
const freeCodeRecordJurisdiction = [];

// 停车收费规则
const parkingChargingRulesJurisdiction = [
  { id: "004014001", label: "添加", children: [] },
  { id: "004014002", label: "删除", children: [] },
  { id: "004014003", label: "修改", children: [] }
];

// 临时停车收费规则
const parkingTemporaryConfigCenterJurisdiction = [
  { id: "004015001", label: "修改", children: [] }
];

// 微信收款账户
const parkingWxAccountManageJurisdiction = [
  { id: "004016001", label: "添加", children: [] },
  { id: "004016002", label: "删除", children: [] },
  { id: "004016003", label: "修改", children: [] }
];

// 支付宝收款账户
const parkingAliAccountManageJurisdiction = [
  { id: "004017001", label: "添加", children: [] },
  { id: "004017002", label: "删除", children: [] },
  { id: "004017003", label: "修改", children: [] }
];

// 优惠券上架
const couponPutOnTheShelvesJurisdiction = [
  { id: "004018001", label: "添加", children: [] },
  { id: "004018002", label: "删除", children: [] },
  { id: "004018003", label: "修改", children: [] }
];

// 优惠券出售
const couponSellJurisdiction = [
  { id: "004019001", label: "添加", children: [] },
  { id: "004019002", label: "删除", children: [] },
  { id: "004019003", label: "修改", children: [] }
];

// 优惠券退劵
const couponRefundJurisdiction = [
  { id: "004020001", label: "添加", children: [] }
];

// 优惠券使用记录
const couponUsageRecordJurisdiction = [
  { id: "004021001", label: "导出", children: [] }
];

// 优惠券商户统计
const couponMerchantStatisticsJurisdiction = [
  { id: "004022001", label: "导出", children: [] }
];

// 免费码授权
const freeCodeAuthorJurisdiction = [
  { id: "004023001", label: "添加", children: [] },
  { id: "004023002", label: "删除", children: [] },
  { id: "004023003", label: "修改", children: [] }
];

// 车场配置
const yardConfigurationJurisdiction = [
  { id: "004026001", label: "修改", children: [] }
];

//设备状态日志
const deviceStatusLogJurisdiction = [
  { id: "004024001", label: "导出", children: [] }
];

//车牌识别记录
const LPRRecordJurisdiction = [
  { id: "004039001", label: "导出", children: [] }
];


// 智慧停车
const parkingServiceJurisdictionChildren = [
  {
    id: "004028000",
    label: "概览",
    routerName: "park-over-view",
    children: []
  },
  {
    id: "004025000",
    label: "车位信息",
    routerName: "parking-lot-manage",
    children: parkingLotManageJurisdiction
  },
  {
    id: "004029000",
    label: "车位区域",
    routerName: "parking-lot-area",
    children: parkingLotAreaJurisdiction
  },
  {
    id: "004030000",
    label: "车位租赁",
    routerName: "parking-rent",
    children: parkingRentJurisdiction
  },
  {
    id: "004031000",
    label: "车位收费规则",
    routerName: "parking-fee-rule",
    children: parkingFeeRuleJurisdiction
  },
  {
    id: "004001000",
    label: "出入口相机",
    routerName: "parking-device-management",
    children: parkingDeviceManagementJurisdiction
  },
  {
    id: "004002000",
    label: "出入口管理",
    routerName: "ent-and-exit-manage",
    children: entAndExitManageJurisdiction
  },
  {
    id: "004003000",
    label: "显示屏管理",
    routerName: "display-manage",
    children: displayManageJurisdiction
  },
  {
    id: "004004000",
    label: "岗亭账号管理",
    routerName: "sentry-box-manage",
    children: sentryBoxJurisdiction
  },
  {
    id: "004005000",
    label: "车辆管理",
    routerName: "authorization-management",
    children: parkingPaymentRecordJurisdiction
  },
  {
    id: "004006000",
    label: "黑名单",
    routerName: "black-list-vehicles-manage",
    children: blackListVehiclesManageJurisdiction
  },
  {
    id: "004007000",
    label: "白名单",
    routerName: "white-list-vehicles-manage",
    children: whiteListVehiclesManageJurisdiction
  },
  {
    id: "004008000",
    label: "包月车辆",
    routerName: "monthly-vehicle",
    children: monthlyVehicleJurisdiction
  },
  {
    id: "004009000",
    label: "在场车辆",
    routerName: "vehicles-on-site",
    children: vehiclesOnSiteJurisdiction
  },
  {
    id: "004010000",
    label: "停车账单",
    routerName: "parking-bill",
    children: parkingBillJurisdiction
  },
  {
    id: "004011000",
    label: "包月账单",
    routerName: "parking-month-bill",
    children: parkingMonthBillJurisdiction
  },
  {
    id: "004012000",
    label: "包月缴费",
    routerName: "monthly-payment",
    children: monthlyPaymentJurisdiction
  },
  {
    id: "004027000",
    label: "临停收费",
    routerName: "temporary-stop",
    children: temporaryStopJurisdiction
  },
  {
    id: "004013000",
    label: "进出记录",
    routerName: "enter-record",
    children: parkingEntryAndExitRecordJurisdiction
  },
  {
    id: "004032000",
    label: "免费码使用记录",
    routerName: "free-code-record",
    children: []
  },
  {
    id: "004014000",
    label: "包月停车收费规则",
    routerName: "parking-month-config-center",
    children: parkingChargingRulesJurisdiction
  },
  {
    id: "004015000",
    label: "临时停车收费规则",
    routerName: "parking-temporary-config-center",
    children: parkingTemporaryConfigCenterJurisdiction
  },
  {
    id: "004016000",
    label: "微信收款账户",
    routerName: "parking-wx-account-manage",
    children: parkingWxAccountManageJurisdiction
  },
  {
    id: "004017000",
    label: "支付宝收款账户",
    routerName: "parking-ali-account-manage",
    children: parkingAliAccountManageJurisdiction
  },
  {
    id: "004018000",
    label: "优惠券上架",
    routerName: "coupon-put-on-the-shelves",
    children: couponPutOnTheShelvesJurisdiction
  },
  {
    id: "004019000",
    label: "优惠券出售",
    routerName: "coupon-sell",
    children: couponSellJurisdiction
  },
  {
    id: "004020000",
    label: "优惠券退劵",
    routerName: "coupon-refund",
    children: couponRefundJurisdiction
  },
  {
    id: "004021000",
    label: "优惠券使用记录",
    routerName: "coupon-usage-record",
    children: couponUsageRecordJurisdiction
  },
  {
    id: "004022000",
    label: "优惠券商户统计",
    routerName: "coupon-merchant-statistics",
    children: couponMerchantStatisticsJurisdiction
  },
  {
    id: "004023000",
    label: "免费码授权",
    routerName: "free-code-author",
    children: freeCodeAuthorJurisdiction
  },
  {
    id: "004026000",
    label: "车场配置",
    routerName: "yard-configuration",
    children: yardConfigurationJurisdiction
  },
  {
    id: "004024000",
    label: "设备状态日志",
    routerName: "device-status-log",
    children: deviceStatusLogJurisdiction
  },
  {
    id: "004039000",
    label: "车牌识别记录",
    routerName: "LPR-record",
    children: LPRRecordJurisdiction
  },
  {
    id: "004006000",
    label: "操作日志",
    routerName: "parking-service-log",
    children: []
  }
];

const parkingServiceJurisdiction = {
  id: "004",
  label: "智慧停车",
  children: parkingServiceJurisdictionChildren
};

export { parkingServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/parkingServiceJurisdiction.js